import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { useBot } from '@/composables/useBot'
import router from '@/router'
import { onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'FlowView',
  setup(__props) {

const route = useRoute()
const flowId = route.params.flowId
const { selectedBot } = useBot()
const iframeUrl = process.env.VUE_APP_CHAT_FLOW_BUILDER_BASE_URL

function handleMessage(event: MessageEvent) {
  // Opcional: verifique a origem por segurança
  const allowedOrigin = process.env.VUE_APP_CHAT_FLOW_BUILDER_BASE_URL
  if (event.origin !== allowedOrigin) return

  if (event.data?.type === 'goBack') {
    window.history.back()
  }

  if (event.data?.type === 'redirect') {
    router.push({
      name: event.data.routeName,
      query: event.data.query
    })
  }
}

onMounted(() => {
  window.addEventListener('message', handleMessage)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("iframe", {
    src: _unref(iframeUrl) + '/bots/' + _unref(selectedBot)?.id + '/flows/' + _unref(flowId) + '/flows-drafts',
    class: "w-full min-h-[85dvh] sm:min-h-[92dvh]"
  }, null, 8, _hoisted_1))
}
}

})